export default "__VITE_ASSET__b0e571d5__"